import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { Performer, colorsByPublicEditProfile } from 'src/app/store/performers.era';
import { Exhibitor, ExhibitorSummary } from 'globals/store/exhibitors.data';
import { JoiEvent, Ranking, LabelMaps, MediaTerms } from 'globals/store/events.data';
import { publicHelpers } from 'globals/helpers/public-helpers';
import { BriefInfo, BriefType, PublicEditProfileInfo, publicEditProfileStatusTypes, CreateEditProfileType } from 'globals/store/share.data';
import { mediaTermColors } from 'globals/store/performers.data';
import { Sponsor } from 'globals/store/sponsors.data';
import { WorkerWithProfile } from 'globals/store/workforce.data';
import { filterVisibleInformableSections, InformableSection } from 'globals/store/informables.data';
import { OnsiteSingleTimeline } from 'globals/store/onsite.data';
import { briefsTimelineReselector, briefTimelineReselectorExtraInputs } from 'src/app/store/reselectors/onsite.reselector';
import { exhibitorBriefActionsReselector, exhibitorSummaryReselector } from 'src/app/store/reselectors/exhibitors.reselector';
import { BriefActions } from 'src/app/store/share.brief.functions';
import { performerBriefActionsReselector } from 'src/app/store/reselectors/performers.reselector';
import { brandDataReselector, briefLogisticsReselector, briefProgramPublishesReselector, briefSharesReselector } from 'src/app/store/reselectors/publish.reselector';
import { BrandingData, BrandingSelectData, LogisticsInBriefSelection, PublishInBriefSelection } from 'globals/store/publish.data';
import { Wrapper } from 'src/app/components/wrapper.component';
import { JoiResource } from 'globals/store/resources.data';
import { resourceBriefActionsReselector } from '../../store/reselectors/resources.reselector';
import { entityInformablesBriefViewReselector, entityMediaTermsReselector, mediaTermsReselector } from '../../store/reselectors/entity.reselector';
import { Dictionary } from '@ngrx/entity';
import { makeMapFromListOfObjectsAndKey } from 'globals/helpers/helpers';
import { Attendee } from 'globals/store/attendees.data';
import { attendeeBriefActionsReselector } from '../../store/reselectors/attendees.reselector';
import { BrandingWrapperComponent } from 'src/app/components/branding/branding-wrapper.component';
import { CommonModule } from '@angular/common';
import { BriefViewComponent } from 'src/app/components/entities/briefView.component';
import { BriefTimelineComponent } from 'src/app/components/entities/briefTimeline.component';

@Component({
    selector: 'app-brief',
    templateUrl: './app-brief.html',
    styles: [`
    .withBranding brief-view { margin: 0 20px; display: block;  }
  `],
    standalone: true,
    imports: [BrandingWrapperComponent, BriefViewComponent, BriefTimelineComponent, CommonModule],
})
export class AppBriefComponent extends Wrapper<AppBriefComponent> implements OnInit {
  @Input() timelineOnly: boolean = false // for resource => logistics
  @Input() performer: Performer
  @Input() exhibitor: Exhibitor
  @Input() resource: JoiResource
  @Input() attendee: Attendee

  event: JoiEvent
  @Input() briefType: BriefType
  @Input() briefInfo: BriefInfo
  mediaTerms: MediaTerms[]

  @Output() close: EventEmitter<void> = new EventEmitter()

  colorsByStatus = mediaTermColors
  publicHelpers = publicHelpers
  lowerEntity = ''
  capitalEntity = ''
  entityId: string
  profileShareable: PublicEditProfileInfo;
  timeline: OnsiteSingleTimeline[]
  exhibitorSummaries: ExhibitorSummary[]
  
  colorsByPublicEditProfile = colorsByPublicEditProfile
  publicEditProfileStatusTypes = publicEditProfileStatusTypes
  statusOptions = Object.keys(publicEditProfileStatusTypes).filter(option=>option!==publicEditProfileStatusTypes.Off)
  
  
  allEntityInformable: InformableSection[] = []

  performers: { [pId: string]: Performer }
  sponsors: { [pId: string]: Sponsor }
  sponsorTypes: { [tId:string]: Ranking }
  labelMaps: LabelMaps
  workersByEmail: { [key:string]: WorkerWithProfile } = {}

  profileType: CreateEditProfileType
  generatingPerformerEditCode = false
  briefActions: BriefActions
  briefProgramPublishes: PublishInBriefSelection[]
  briefLogisticsViews: LogisticsInBriefSelection[]
  briefOnsiteViews: LogisticsInBriefSelection[]

  singleEntityInformable: InformableSection[] = []
  brandingData: BrandingData
  performerRoles: Dictionary<Ranking>

  constructor() {
    super()
    this.subProp(this.store.select('performers', 'entities'), 'performers')
    this.subProp(this.store.select('sponsors', 'entities'), 'sponsors')
    this.subProp(this.store.select('sponsors', 'sponsorTypes'), 'sponsorTypes')
    this.subProp(this.store.select('events','labelMaps'), 'labelMaps')
    this.subProp(this.store.select('workforce', 'workersByEmail'), 'workersByEmail')
    this.subCallback(this.store.select('events'), ({ event, labelMaps }) => {
      this.event = event
      this.performerRoles = makeMapFromListOfObjectsAndKey(event?.performerRoles || [], 'id')
    })
  }

  ngOnInit() {
    this.lowerEntity = this.briefType  
    this.capitalEntity = this.briefType[0].toUpperCase() + this.briefType.slice(1)
    switch (this.briefType) {
      case 'attendee':
        this.entityId = this.attendee.id
        this.profileType = 'attendee'
        break
      case 'performer':
        this.entityId = this.performer.id
        this.profileType = 'profile'
        break
      case 'exhibitor':
        this.entityId = this.exhibitor.id
        this.profileType = 'exhibitor'
        break
      case 'resource':
        this.entityId = this.resource.id
        this.profileType = 'resource'
        break
    }
    const brandingSelectData: BrandingSelectData = {
      type: 'forms',
      brandFormType: 'briefs'
    }
    this.selectProp(brandDataReselector, brandingSelectData, 'brandingData')

    this.selectProp(entityMediaTermsReselector, { type: this.briefType, id: this.entityId }, 'mediaTerms')
    
    this.subCallback(this.store.select('informables', this.briefType, this.entityId), entityInformable => {
      console.log({ briefType: this.briefType, id: this.entityId, entityInformable })
      if (!entityInformable) return this.singleEntityInformable = null
      this.singleEntityInformable = filterVisibleInformableSections(entityInformable.info)
    })

    const briefActionsReselector = this.briefType === 'performer' ? performerBriefActionsReselector : 
    this.briefType === 'exhibitor' ? exhibitorBriefActionsReselector : this.briefType === 'attendee' ? attendeeBriefActionsReselector :  resourceBriefActionsReselector
    this.selectProp(briefActionsReselector, this.entityId, 'briefActions')
  
    this.subProp(this.store.select(briefProgramPublishesReselector, this.briefType), 'briefProgramPublishes')
    this.subProp(this.store.select(briefLogisticsReselector, this.briefType), 'briefLogisticsViews')
    this.subProp(this.store.select(briefSharesReselector, this.briefType), 'briefOnsiteViews')

    const extraInputs: briefTimelineReselectorExtraInputs = this.briefType === 'performer' ?
      { performerId: this.performer.id } : this.briefType === 'exhibitor' ? { exhibitorId: this.exhibitor.id } : this.briefType === 'attendee' ? { attendeeId: this.attendee.id } : { resourceId: this.resource.id }

    this.subProp(this.store.select(briefsTimelineReselector, extraInputs), 'timeline')
    this.subCallback(this.store.select('shareables', this.profileType, this.entityId), (profileShareable) => {
      if (profileShareable) this.profileShareable = profileShareable
    })

    this.selectProp(entityInformablesBriefViewReselector, { entityId: this.entityId, informableKey: this.briefType === 'exhibitor' ? 'exhibitors' : this.briefType === 'resource' ? 'resources' : this.briefType === 'attendee' ? 'attendees' : 'performers' }, 'allEntityInformable')

    if (this.briefType === 'exhibitor') this.subProp(this.store.select(exhibitorSummaryReselector, this.exhibitor.id), 'exhibitorSummaries')
  }



}

